export default __webpack_public_path__ + "static/media/top-logo.8134f227.svg";